import * as types from '@/store/mutation-types';
import { namespacedActions as companyFilesActions } from '@/store/companyFiles/actionTypes';
import api from '@/store/api';
import router from '@/router';
import log from '@/logger';

export const logout = function ({ commit, state }, credentials) {
  commit(types.setLoggedIn, false);
  router.push({ name: 'Login' });
  // Delete pouch db here
};

export const login = function ({ commit, state, dispatch }, credentials) {
  log.init(credentials.username);
  commit(types.setIsBusy, 1);

  return api
    .login(state, dispatch, credentials)
    .then(async (user) => {
      commit(types.setUser, user);

      await dispatch('updateProjectList');
      await dispatch('updateStateCompanies');
      await dispatch(companyFilesActions.syncCompanyFilesList);
      await dispatch('updateStatePersons');
      // await dispatch('updateStateKeyword');

      commit(types.setLoggedIn, true);
      commit(types.setIsBusy, -1);

      return true;
    })
    .catch((err) => {
      log.error('Login error', err);
      commit(types.setLoggedIn, false);
      router.push({ name: 'Login' });
      commit(types.setIsBusy, -1);
      return false;
    });
};



// WEBPACK FOOTER //
// ./src/store/user/userActions.js